import React, { useRef, useState } from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useTranslation } from 'react-i18next';

const FileUpload = ({ chooseFile } : { chooseFile: Function }) => {
    const { t } = useTranslation();
    const inputRef = useRef<HTMLInputElement | null>(null);
    const [isDragging, setIsDragging] = useState(false);
  
    const openFileDialog = () => {
        if(inputRef && inputRef.current) 
        {
            inputRef!.current.click();
        }
    };

    const uploadFile = async (file: any) => {
        if (!file) return;

        await chooseFile(file);
        if (inputRef.current) {
            inputRef.current.value = '';
        }
    };
  
    const handleDrop = (event : any) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file) {
            chooseFile(file);
        }
        setIsDragging(false); 
    };

    const borderColor = isDragging ? 'green' : 'gray';
    const borderStyle = isDragging ? 'dashed' : 'dotted';

    const handleFileInputChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        await uploadFile(file);
        if (inputRef.current) {
            inputRef.current.value = '';
        }
    };
    
    return (
        <Paper
            onDragOver={(e) => {
                e.preventDefault();
                setIsDragging(true);
            }}
            onDragLeave={() => setIsDragging(false)}
            onDrop={(e) => handleDrop(e)}
            onClick={openFileDialog}
            style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                padding: '5px',
                border: `2.5px ${borderStyle} ${borderColor}`,
                borderRadius: '10px',
                width: '100%'
            }}
        >
            <input
                ref={inputRef}
                type="file"
                style={{ display: 'none' }}
                onChange={(e) => handleFileInputChange(e)}
            />
            <CloudUploadIcon id="file-upload-button-icon" style={{ marginRight: '10px', fontSize: '28px' }} />
            <Typography id="file-upload-button-text" variant="h6" style={{ fontWeight: 'bold', margin: '0' }}>
                {t('FILE_UPLOAD_TEXT')}
            </Typography>
        </Paper>
    );
};

export default FileUpload;